module.exports = __webpack_public_path__ + "images/category_lp/watch/omega_samples/sec05_pc_6260da22d4f6bb05724245db81fa4e7e.jpg";